<template>
  <div
    id="verify-2fa-modal"
    scroll="keep"
  >
    <div class="modal-header">
      {{ $t('two_factors.verify_2fa') }}
    </div>
    <div>
      <b-field :label="$t('two_factors.enter_2fa_code')">
        <b-input
          v-model="code"
          :placeholder="$t('two_factors.enter_2fa_code')"
          @keyup.enter.native="submit"
        />
      </b-field>
    </div>
    <b-button
      :loading="isLoading"
      class="submit-btn"
      @click="submit"
    >
      {{ $t('buttons.submit') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'Verify2FAModal',
  data: () => ({
    code: '',
    isLoading: false
  }),
  beforeDestroy () {
    this.$emit('close')
  },
  methods: {
    submit () {
      if (this.code) {
        this.isLoading = true
        this.$emit('submit', this.code)
        this.$emit('close')
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'Please fill the code from Google Authentication.'
        })
      }
    },
    updateIsLoading (value) {
      this.isLoading = Boolean(value)
    }
  }
}
</script>

<style lang="scss">
#verify-2fa-modal {
  .modal-content {
    overflow: hidden;
    width: 675px;
  }
}
</style>

<style lang="scss" scoped>
.modal-card {
  background-color: #fff;
  border-radius: 5px;
  padding: 30px 40px;
}
.modal-header {
  margin-bottom: 30px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.alert-msg {
  color: #2193ff;
}
.submit-btn {
  float: left;
  width: 100%;
  margin: 10px auto;
  padding: 9px;
  border: unset;
  color: #fff;
  font-weight: bold;
  background-color: #2193ff;
  border-radius: 3px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
.show-on-desktop {
  display: block;
}
.show-on-mobile {
  display: none;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  #verify-2fa-modal {
    // width: 90vw;
    // min-width: 0;
    margin: 0 auto;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .modal-card {
    padding: 7%;
  }
  .modal-header {
    margin-bottom: 7%;
  }
  #verify-2fa-modal {
    margin-top: 7%;
  }
}

/* iPhone 5/SE */
@media only screen and (max-width: 320px) {
  #verify-2fa-modal {
    margin-top: calc(7% + 10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Verify2FAModal.vue